import { render, staticRenderFns } from "./EjercicioPicker.vue?vue&type=template&id=643b1e6c&"
import script from "./EjercicioPicker.vue?vue&type=script&lang=js&"
export * from "./EjercicioPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports